import React from "react";

const DataName = () => {
  return (
    <div className="search_data_name">
      <label>Name</label>
      <label>Handle</label>
      <label>Followers</label>
      <label>edit/delete</label>
    </div>
  );
};

export default DataName;
